package com.example.mystybag.login.views

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p124
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.login.logic.AddLocationPromptViewModel
import com.example.mystybag.login.views.views.AddLocationPromptWebView
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun AddLocationPromptView(viewModel: AddLocationPromptViewModel) {
    if (PlatformHelper.isWeb) {
        AddLocationPromptWebView(viewModel)
        return
    }

    val colors = AppTheme.current.colors

    UIView(
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = p16),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Spacer(modifier = Modifier.height(p24))

            Image(
                painter = painterResource(SRC.images.add_location_icon),
                contentDescription = null,
                modifier = Modifier.size(p124),
                contentScale = ContentScale.Fit
            )

            Spacer(modifier = Modifier.height(p32))

            Texts.HeadlineLarge(
                text = stringResource(SR.strings.add_your_first_location),
                textAlign = TextAlign.Center,
                color = colors.onSurface,
                modifier = Modifier.fillMaxWidth()
            )

            Spacer(modifier = Modifier.height(p12))

            Texts.BodyLarge(
                text = stringResource(SR.strings.add_location_prompt_message),
                textAlign = TextAlign.Center,
                color = colors.onSurface,
                modifier = Modifier.fillMaxWidth()
            )

            Spacer(modifier = Modifier.weight(1f))

            DefaultButton(
                caption = stringResource(SR.strings.get_started),
                callback = {
                    viewModel.onGetStarted()
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = p8)
            )
        }
    }
}
